import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { extHostCustomer } from '../../services/extensions/common/extHostCustomers.js';
import { raceCancellationError } from 'vscode/vscode/vs/base/common/async';
import { IEditSessionIdentityService } from 'vscode/vscode/vs/platform/workspace/common/editSessions.service';
import { ExtHostContext } from 'vscode/vscode/vs/workbench/api/common/extHost.protocol';

const _moduleId = "vs/workbench/api/browser/mainThreadEditSessionIdentityParticipant";
class ExtHostEditSessionIdentityCreateParticipant {
    constructor(extHostContext) {
        this.timeout = 10000;
        this._proxy = ( (extHostContext.getProxy(ExtHostContext.ExtHostWorkspace)));
    }
    async participate(workspaceFolder, token) {
        const p = ( (new Promise((resolve, reject) => {
            setTimeout(() => reject(( (new Error(( localizeWithPath(
                _moduleId,
                0,
                "Aborted onWillCreateEditSessionIdentity-event after 10000ms"
            )))))), this.timeout);
            this._proxy.$onWillCreateEditSessionIdentity(workspaceFolder.uri, token, this.timeout).then(resolve, reject);
        })));
        return raceCancellationError(p, token);
    }
}
let EditSessionIdentityCreateParticipant = class EditSessionIdentityCreateParticipant {
    constructor(extHostContext, instantiationService, _editSessionIdentityService) {
        this._editSessionIdentityService = _editSessionIdentityService;
        this._saveParticipantDisposable = this._editSessionIdentityService.addEditSessionIdentityCreateParticipant(instantiationService.createInstance(ExtHostEditSessionIdentityCreateParticipant, extHostContext));
    }
    dispose() {
        this._saveParticipantDisposable.dispose();
    }
};
EditSessionIdentityCreateParticipant = __decorate([
    extHostCustomer,
    ( (__param(1, IInstantiationService))),
    ( (__param(2, IEditSessionIdentityService)))
], EditSessionIdentityCreateParticipant);

export { EditSessionIdentityCreateParticipant };
